import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Link} from 'react-router-dom';
import "./App.css";
//import Preloader from "./Preloader";
import TextPressure from "./TextPressure";
import Hyperspeed from "./Hyperspeed";
import ScrollVelocity from "./ScrollVelocity";
import SpotlightCard from "./SpotlightCard";
import TrueFocus from "./TrueFocus";
import AnimatedContent from "./AnimatedContent";
import GradientText from './GradientText'
import TestimonialsSection from './TestimonialsSection';
import PricingSection from './myComponents/PricingSection';
import Footer from './myComponents/Footer';
import FAQSection from './myComponents/FAQSection';
import CTASection from './myComponents/CTASection';
import Menu from './myComponents/Menu';
import SetupIOSPage from './pages/ios';
import SetupRegion from './pages/region';
import SetupAndroidPage from './pages/android';
import SetupWindowsPage from './pages/windows';
import SetupLinuxPage from './pages/linux';
import SetupRouterPage from './pages/router';
import SetupMainPage from './pages/SetupMainPage';

import ScrollToTop from './lib/ScrollToTop';


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
 faShield,
 faBolt,
 faGlobe,
 faLock,
 faRocket,
} from "@fortawesome/free-solid-svg-icons";

import { 
 BsDownload, 
 BsPhone, 
 BsWifi,
 BsShield,
 BsLock,
 BsLightning
} from "react-icons/bs";
import { 
 FaWindows, 
 FaApple, 
 FaLinux, 
 FaAndroid 
} from "react-icons/fa";

function MainPage() {
 //const [loading, setLoading] = useState(true);
 //const [preloaderClass, setPreloaderClass] = useState('');

 //useEffect(() => {
  //  const handleLoad = async () => {
  //    try {
  //      // Ждем загрузки шрифтов
  //      await document.fonts.ready;
       
  //      // Дополнительная задержка для загрузки всех ресурсов
  //      setTimeout(() => {
  //        setPreloaderClass('preloader-exit');
         
  //        // Убираем прелоадер после анимации
  //        setTimeout(() => {
  //          setLoading(false);
  //        }, 500);
  //      }, 2000); // Минимум 2 секунды показа прелоадера
       
  //    } catch (error) {
  //      // Если что-то пошло не так, убираем прелоадер через 3 секунды
  //      setTimeout(() => {
  //        setPreloaderClass('preloader-exit');
  //        setTimeout(() => {
  //          setLoading(false);
  //        }, 500);
  //      }, 3000);
  //    }
  //  };

   // Проверяем готовность документа
  //  if (document.readyState === 'complete') {
  //    handleLoad();
  //  } else {
  //    window.addEventListener('load', handleLoad);
  //  }

   //return () => window.removeEventListener('load', handleLoad);
 //}, []);

//  if (loading) {
//    return <div className={preloaderClass}><Preloader /></div>;
//  }

 return (
   <div className="App">
     {/* Hero Section */}
     <section className="hero-section">
       {/* Hyperspeed Background */}
       <div className="hyperspeed-container">
         <Hyperspeed
           effectOptions={{
             onSpeedUp: () => {},
             onSlowDown: () => {},
             distortion: "mountainDistortion",
             length: 400,
             roadWidth: 9,
             islandWidth: 2,
             lanesPerRoad: 3,
             fov: 90,
             fovSpeedUp: 150,
             speedUp: 2,
             carLightsFade: 0.4,
             totalSideLightSticks: 50,
             lightPairsPerRoadWay: 50,
             shoulderLinesWidthPercentage: 0.05,
             brokenLinesWidthPercentage: 0.1,
             brokenLinesLengthPercentage: 0.5,
             lightStickWidth: [0.12, 0.5],
             lightStickHeight: [1.3, 1.7],
             movingAwaySpeed: [60, 80],
             movingCloserSpeed: [-120, -160],
             carLightsLength: [400 * 0.05, 400 * 0.15],
             carLightsRadius: [0.05, 0.14],
             carWidthPercentage: [0.3, 0.5],
             carShiftX: [-0.2, 0.2],
             carFloorSeparation: [0.05, 1],
             colors: {
               roadColor: 0x1a0a0a,
               islandColor: 0x0f0505,
               background: 0x000000,
               shoulderLines: 0x330a0a,
               brokenLines: 0x4d1515,
               leftCars: [0xff0000, 0xcc0000, 0x990000],
               rightCars: [0xff4444, 0xff6666, 0xff8888],
               sticks: 0xff0000,
             },
           }}
         />
       </div>

       {/* Dark overlay */}
       <div className="overlay"></div>

       {/* Navigation Menu */}
       <Menu/>

       {/* Hero Content */}
       <div className="content">
         <div className="title-container">
           {/* Trust indicators */}
           <div className="hero-trust">
             <div className="hero-stats">
               {/* <div className="hero-stat">
                 <span className="hero-number">2000+</span>
                 <span className="hero-label">пользователей</span>
               </div>*/}
               <div className="hero-rating">
                 <span className="hero-stars">★★★★★</span>
                 <span className="hero-label">4.9 рейтинг</span>
               </div>
               <div className="hero-stat">
                 <span className="hero-number">99.9%</span>
                 <span className="hero-label">аптайм</span>
               </div>
             </div>
           </div>
           <div className="desktop-title">
             <TextPressure
               text="Fast. Secure. RED."
               flex={true}
               alpha={false}
               stroke={false}
               width={true}
               weight={true}
               italic={true}
               textColor="#ff0000"
               strokeColor="#990000"
               minFontSize={100}
             />
           </div>
           <h1 className="mobile-title">Fast. Secure. RED.</h1>
         </div>

         <h2 className="subtitle">
           Скоростной VPN с военным шифрованием. Работает там, где другие не справляются.
         </h2>

         <button 
          className="cta-button"
          onClick={() => {
            document.getElementById('next').scrollIntoView({
              behavior: 'smooth'
            });
          }}
        >
          ПОПРОБОВАТЬ
        </button>
       </div>

       {/* Bottom decoration */}
       <div className="bottom-decoration">
         <div className="speed-indicator">
           <span className="speed-dot"></span>
           <span className="speed-text">НАЖМИ И УДЕРЖИВАЙ</span>
         </div>
       </div>
     </section>

     {/* Features Section */}
     <section className="features-section" id="next">
       <AnimatedContent
         distance={150}
         direction="vertical"
         reverse={false}
         duration={1}
         ease="power3.out"
         initialOpacity={0}
         animateOpacity
         scale={1}
         threshold={0}
         delay={0}
       >
         <h1>
           <div className="desktop-animation">
             <TrueFocus
               sentence="Доступ туда, куда больше нельзя"
               manualMode={true}
               blurAmount={7}
               borderColor="red"
               animationDuration={0.4}
               pauseBetweenAnimations={0.1}
             />
           </div>
           <div className="mobile-simple-text">
             Доступ туда, куда больше нельзя
           </div>
         </h1>
       </AnimatedContent>

       <AnimatedContent
         distance={150}
         direction="vertical"
         reverse={false}
         duration={1}
         ease="power3.out"
         initialOpacity={0}
         animateOpacity
         scale={1}
         threshold={0}
         delay={0}
       >
         <div className="cards-wrapper">
           <SpotlightCard
             className="custom-spotlight-card card1"
             spotlightColor="rgba(255, 0, 0, 0.35)"
           >
             <div className="card-content">
               <FontAwesomeIcon icon={faShield} className="card-icon" />
               <h3 className="card-title">XRAY Обфускация</h3>
               <p className="card-description">
                 Маскировка через HTTPS делает ваш трафик неотличимым
                 от обычного веб-серфинга. Работает даже в самых жёстких сетях
               </p>
             </div>
           </SpotlightCard>

           <SpotlightCard
             className="custom-spotlight-card card2"
             spotlightColor="rgba(255, 0, 0, 0.35)"
           >
             <div className="card-content">
               <FontAwesomeIcon icon={faBolt} className="card-icon" />
               <h3 className="card-title">Работает с мобильным трафиком</h3>
               <p className="card-description">
                 Высокопроизводительный протокол, который превосходит
                 WireGuard, Outline и ShadowSocks. Устойчив к глубокой
                 инспекции пакетов любых провайдеров
               </p>
             </div>
           </SpotlightCard>

           <SpotlightCard
             className="custom-spotlight-card card3"
             spotlightColor="rgba(255, 0, 0, 0.35)"
           >
             <div className="card-content">
               <FontAwesomeIcon icon={faGlobe} className="card-icon" />
               <h3 className="card-title">Множество локаций</h3>
               <p className="card-description">
                 Серверы в десятках стран — выбирайте любую локацию
                 для максимальной скорости и свободы
               </p>
             </div>
           </SpotlightCard>

           <SpotlightCard
             className="custom-spotlight-card card4"
             spotlightColor="rgba(255, 0, 0, 0.35)"
           >
             <div className="card-content">
               <FontAwesomeIcon icon={faLock} className="card-icon" />
               <h3 className="card-title">Строгий No-Logs</h3>
               <p className="card-description">
                 Ваша приватность священна! Мы физически не можем передать ваши
                 данные - их просто не существует
               </p>
             </div>
           </SpotlightCard>

           <SpotlightCard
             className="custom-spotlight-card card5"
             spotlightColor="rgba(255, 0, 0, 0.35)"
           >
             <div className="card-content">
               <FontAwesomeIcon icon={faRocket} className="card-icon" />
               <h3 className="card-title">10Gbps Скорость</h3>
               <p className="card-description">
                 Наши серверы работают на скорости до 10 Гбит/с. Смотрите
                 Netflix и Disney+ в 4К без задержек.
               </p>
             </div>
           </SpotlightCard>
         </div>
       </AnimatedContent>
     </section>

     <ScrollVelocity
       texts={["RED BUTTON RED BUTTON", "VPN VPN VPN VPN VPN VPN", "RED BUTTON RED BUTTON"]}
       velocity={100}
       className="custom-scroll-text"
     />

     {/* Devices Section */}
     <AnimatedContent
         distance={150}
         direction="vertical"
         reverse={false}
         duration={1}
         ease="power3.out"
         initialOpacity={0}
         animateOpacity
         scale={1}
         threshold={0}
         delay={0}
       >
      <section className="devices-section">
        <div className="devices-content">
          <div className="devices-text">
            <div className="trust-badge">Везде и всегда</div>
            <GradientText
              colors={["#ff0000", "#ffffff", "#ff0000", "#ffffff", "#ff0000"]}
              animationSpeed={10}
              showBorder={false}
              className="devices-title"
            >
              Один VPN для всей цифровой жизни
            </GradientText>
            <p className="devices-description">
              Смотрите Netflix в 4K на телевизоре, работайте безопасно на ноутбуке, 
              сидите в соцсетях на телефоне. RED BUTTON защищает все ваши устройства 
              одновременно на полной скорости.
            </p>

            <button 
              className="devices-cta"
              onClick={() => {
                document.getElementById('pricing').scrollIntoView({
                  behavior: 'smooth'
                });
              }}
            >
              <BsDownload className="cta-icon" />
              Установить за 30 секунд
            </button>
            
            <div className="platforms-grid">
              <div className="platform-item">
                <FaWindows className="platform-icon" />
                <span>Windows</span>
              </div>
              <div className="platform-item">
                <FaApple className="platform-icon" />
                <span>macOS</span>
              </div>
              <div className="platform-item">
                <BsPhone className="platform-icon" />
                <span>iPhone</span>
              </div>
              <div className="platform-item">
                <FaAndroid className="platform-icon" />
                <span>Android</span>
              </div>
              <div className="platform-item">
                <FaLinux className="platform-icon" />
                <span>Linux</span>
              </div>
              <div className="platform-item">
                <BsWifi className="platform-icon" />
                <span>Роутер</span>
              </div>
            </div>
          </div>
          
          <div className="devices-visual">
            <div className="floating-tech-hub">
              {/* Центральный элемент */}
              <div className="tech-hub-center">
                <div className="hub-pulse"></div>
                <span>VPN</span>
              </div>
              
              {/* Плавающие карточки */}
              <div className="floating-card card-1">
                <BsShield />
              </div>
              <div className="floating-card card-2">
                <BsLock />
              </div>
              <div className="floating-card card-3">
                <BsLightning />
              </div>
              <div className="floating-card card-4">
                <BsWifi />
              </div>
              <div className="floating-card card-5">
                <BsPhone />
              </div>
              <div className="floating-card card-6">
                <FaWindows />
              </div>
            </div>
          </div>
        </div>
      </section>
     </AnimatedContent>
     
     <AnimatedContent
         distance={150}
         direction="vertical"
         reverse={false}
         duration={1}
         ease="power3.out"
         initialOpacity={0}
         animateOpacity
         scale={1}
         threshold={0}
         delay={0}
       >
     <TestimonialsSection />
     </AnimatedContent>

     <AnimatedContent
         distance={150}
         direction="vertical"
         reverse={false}
         duration={1}
         ease="power3.out"
         initialOpacity={0}
         animateOpacity
         scale={1}
         threshold={0}
         delay={0}
       >
     <PricingSection id="pricing"/>
     </AnimatedContent>

     <AnimatedContent
         distance={150}
         direction="vertical"
         reverse={false}
         duration={1}
         ease="power3.out"
         initialOpacity={0}
         animateOpacity
         scale={1}
         threshold={0}
         delay={0}
       >
     <CTASection />
     </AnimatedContent>

     <AnimatedContent
         distance={150}
         direction="vertical"
         reverse={false}
         duration={1}
         ease="power3.out"
         initialOpacity={0}
         animateOpacity
         scale={1}
         threshold={0}
         delay={0}
       >
     <FAQSection id="faq"/>
     </AnimatedContent>

     <AnimatedContent
         distance={150}
         direction="vertical"
         reverse={false}
         duration={1}
         ease="power3.out"
         initialOpacity={0}
         animateOpacity
         scale={1}
         threshold={0}
         delay={0}
       >
     <Footer id="footer"/>
     </AnimatedContent>


   </div>
 );
}

export default function App() {
 return (
   <Router>
    <ScrollToTop />
     <Routes>
       <Route path="/setup/ios" element={<SetupIOSPage />} />
       <Route path="/setup/region" element={<SetupRegion />} /> 
       <Route path="/setup/windows" element={<SetupWindowsPage />} />
       <Route path="/setup/router" element={<SetupRouterPage />} />
       <Route path="/setup/linux" element={<SetupLinuxPage />} />
       <Route path="/setup/android" element={<SetupAndroidPage />} />
       <Route path="/setup" element={<SetupMainPage />} />
       <Route path="/" element={<MainPage />} />
     </Routes>
   </Router>
 );
}